/* eslint-disable no-shadow */
/* eslint-disable yoda */
/* eslint-disable no-plusplus */
import { useState, useEffect } from "react";
import { Map, GoogleApiWrapper, Marker } from "google-maps-react";
import { Row, Col } from "react-flexbox-grid";
import { Button } from "components/core";
import Geocode from "react-geocode";
import { API_KEY_MAPS } from "constants/index";
import Typography from "@material-ui/core/Typography";
import styled from "styled-components";
import classes from "./Map.module.css";

Geocode.setApiKey(API_KEY_MAPS);
Geocode.enableDebug();

const ContainerInfo = styled.div`
  min-width: 200px;
  max-height: 200px;
  width: 92vw;
  height: 100%;
  bottom: -44em;
  position: absolute;
  background: #ffffff82;
  border-radius: 8px;
  padding: 1em;

  @media only screen and (min-width: 360px) and (max-width: 479px) {
    bottom: -35em;
  }

  /*--------------------------------------------------------------
      small mobile
  ----------------------------------------------------------------*/

  @media only screen and (min-width: 320px) and (max-width: 359px) {
    bottom: -35em;
  }
`;

const containerStyle = {
  width: "100%",
  height: "100%",
};

const defaultCenter = { lat: 19.436955426307716, lng: -99.14131267271615 };

const MapContainer = ({
  google,
  mapStyle,
  onChange = () => null,
  onExit,
  ...rest
}) => {
  const [currentPosition, setCurrentPosition] = useState(null);
  const [location, setLocation] = useState(null);

  const getState = (addressArray) => {
    let state = "";
    for (let i = 0; i < addressArray.length; i++) {
      for (let i = 0; i < addressArray.length; i++) {
        if (
          addressArray[i].types[0] &&
          "administrative_area_level_1" === addressArray[i].types[0]
        ) {
          state = addressArray[i].long_name;
          return state;
        }
      }
    }

    return state;
  };

  const getStreet = (addressArray) => {
    let street = "";
    for (let i = 0; i < addressArray.length; i++) {
      if (addressArray[i].types[0] && "route" === addressArray[i].types[0]) {
        street = `${addressArray[i].long_name} ${addressArray[0].long_name}`;
        return street;
      }
    }

    return street;
  };

  const getCity = (addressArray) => {
    let city = "";
    for (let i = 0; i < addressArray.length; i++) {
      if (addressArray[i].types[0] && "locality" === addressArray[i].types[0]) {
        city = addressArray[i].long_name;
        return city;
      }
    }

    return city;
  };

  const getSuburb = (addressArray) => {
    let area = "";
    for (let i = 0; i < addressArray.length; i++) {
      if (addressArray[i].types[0]) {
        for (let j = 0; j < addressArray[i].types.length; j++) {
          if ("sublocality_level_1" === addressArray[i].types[j]) {
            area = addressArray[i].long_name;
            return area;
          }
        }
      }
    }

    return area;
  };

  const getCurrentPlace = async (lat, lng) => {
    const response = await Geocode.fromLatLng(lat, lng);

    try {
      const address = response.results[0].formatted_address;
      const addressArray = response.results[0].address_components;
      const city = getCity(addressArray);
      const street = getStreet(addressArray);
      const neighborhood = getSuburb(addressArray);
      const state = getState(addressArray);

      onChange({
        address,
        city,
        street,
        neighborhood,
        state,
        coordinates: { latitude: lat, longitude: lng },
      });
      setLocation({
        address,
        city,
        street,
        neighborhood,
        state,
      });
    } catch (error) {
      console.error(error);
    }
  };

  const moveMarker = (c, _, e) => {
    const lat = e.latLng.lat();
    const lng = e.latLng.lng();
    getCurrentPlace(lat, lng);
    setCurrentPosition({ lat, lng });
  };

  const success = ({ coords }) => {
    const { latitude, longitude } = coords;
    const currentPositionScope = {
      lat: latitude,
      lng: longitude,
    };
    getCurrentPlace(latitude, longitude);
    setCurrentPosition(currentPositionScope);
  };

  const onSelectAddress = () => {
    if (location?.address) {
      onExit();
    } else {
      // eslint-disable-next-line no-alert
      alert("Arrastra el marcador para obtener la dirección");
    }
  };

  useEffect(() => {
    navigator.geolocation.getCurrentPosition(success);
  }, []);

  if (!google) {
    return <div>Loading...</div>;
  }

  return (
    <>
      <Map
        {...rest}
        defaultZoom={15}
        google={google}
        className={classes.containerMap}
        containerStyle={containerStyle}
        defaultCenter={defaultCenter}
        center={currentPosition?.lat ? currentPosition : defaultCenter}
      >
        <Marker
          draggable
          title="Ubicación actual"
          position={currentPosition?.lat ? currentPosition : defaultCenter}
          onDragend={moveMarker}
        />
      </Map>
      <ContainerInfo>
        <Row center="xs">
          <Col md={12}>
            <Typography variant="body2" color="secondary">
              Tu dirección es
            </Typography>
          </Col>
          <Col md={12} className="mt2">
            <Typography variant="body2" color="textSecondary">
              {location?.address || ""}
            </Typography>
          </Col>
          <Col md={12} className="mt3">
            <Button onClick={onSelectAddress}>GUARDAR</Button>
          </Col>
        </Row>
      </ContainerInfo>
    </>
  );
};

export default GoogleApiWrapper({ apiKey: API_KEY_MAPS })(MapContainer);
